import { BASE_CABINET } from '../containers/Configurator/constants/furniture';

export type LanguageConfigurator = 'fr' | 'nl' | 'en' | 'de';

export interface FurnitureCallbackInfos {
  name: string;
  description: string;
  price: string;
  quantity: number;
}

export interface Properties {
  baseApiUrL?: string;
  baseSiteUrl?: string;
  saveForLaterUrL?: string;
  product?: string;
  language: LanguageConfigurator;
  configuratorDidLoadCallback?: () => void;
  furnitureDidUpdateCallback?: (furniture: FurnitureCallbackInfos) => void;
  addToCartCallback?: (id: number) => void;
  addToCurrentOrderCallback?: (
    id: number,
    priceTaxExcl: number,
    priceTaxIncl: number,
  ) => void;
  saveCallback?: (id: number) => void;
  shopEmployee?: string;
  shopName?: string;
  shopContact?: string;
  shopPhone?: string;
  editInOrder?: boolean;
  vat?: number;
  resellerRate?: number;
  decimalSeparator?: string;
  thousenSeparator?: string;
}

let properties: Properties;
// @ts-ignore
if (window.kewconfProperties) {
  // @ts-ignore
  properties = window.kewconfProperties;
} else {
  properties = {
    product: BASE_CABINET,
    language: 'fr',
  };
}

if (properties.baseApiUrL === undefined) {
  properties.baseApiUrL = `${process.env.REACT_APP_API_URL}`;
}

if (properties.baseSiteUrl === undefined) {
  properties.baseSiteUrl = `${process.env.REACT_APP_HOST_URL}`;
}

if (properties.saveForLaterUrL === undefined) {
  properties.saveForLaterUrL = `${process.env.REACT_APP_HOST_URL}/shop/modules/sendtoafriend/sendtoafriend_ajax.php`;
}

if (properties.vat === undefined) {
  // Belgian VAT by default
  properties.vat = 1.21;
}

if (!properties.resellerRate) {
  // Only apply for shop
  properties.resellerRate = 1;
}

if (!properties.decimalSeparator) {
  properties.decimalSeparator = ',';
}

if (!properties.thousenSeparator) {
  properties.thousenSeparator = ' ';
}

export default properties;
